'use strict';
var utils = require('../util/utils');
var cache = {};

var scrollPosition = 0;
var isLocked = false;

/**
 * Handles touchmove events to prevent scrolling on iOS.
 * Allows scrolling within the drawer content itself.
 * @param {Event} e - The touchmove event
 */
var touchMoveHandler = function (e) {
    if (e.target.closest('#drawerContent')) {
        return;
    }
    e.preventDefault();
};

/**
 * Locks page scroll when the drawer opens.
 * Applies the drawer-scroll-locked class and sets the top offset to maintain visual scroll position.
 */
function lockScroll() {
    if (isLocked) return;

    scrollPosition = window.pageYOffset || 0;
    isLocked = true;

    cache.$body
        .addClass('drawer-scroll-locked')
        .css('top', -scrollPosition + 'px');

    // Add touch scroll prevention (iOS)
    document.addEventListener('touchmove', touchMoveHandler, { passive: false });
}

/**
 * Unlocks page scroll when the drawer closes.
 * Removes the drawer-scroll-locked class and restores the original scroll position.
 */
function unlockScroll() {
    if (!isLocked) return;

    isLocked = false;

    cache.$body
        .removeClass('drawer-scroll-locked')
        .css('top', '');

    if (scrollPosition > 0) {
        window.scrollTo(0, scrollPosition);
    }
    scrollPosition = 0;

    // Remove touch scroll prevention (iOS)
    document.removeEventListener('touchmove', touchMoveHandler, { passive: false });
}

/**
 * Init promoDrawer events
 */
function initPromoDrawer() {
    cache.$overlay = $('.modal-background');
    cache.$body = $('body');

    var $drawerContent = $('#drawerContent');

    if (!$drawerContent.length) return;

    cache.$overlay.on('click', function () {
        if ($drawerContent.hasClass('show')) {
            cache.$overlay.hide();
            $('.drawer-toggler').click();
        }
    });

    if ($('.showModal').length > 0) {
        cache.$overlay.show();
        lockScroll();
    }

    $drawerContent
        .on('shown.bs.collapse', function () {
            cache.$overlay.show();
            if ($('.drawer-carousel').hasClass('slick-initialized')) {
                $('.drawer-carousel').slick('slickSetOption', 'draggable', true, true);
            }
            $('.drawer-carousel').trigger('carousel:slidesToShow');
            var $closeButtonDrawer = $('button.close-content');
            utils.addAriaLabel($closeButtonDrawer, $drawerContent.attr('data-close-button-aria'));
        })
        .on('show.bs.collapse', function () {
            cache.$body.addClass('drawer-open');
            cache.$overlay.fadeIn(100);
            lockScroll();
        })
        .on('hide.bs.collapse', function () {
            cache.$body.removeClass('drawer-open');
            cache.$overlay.hide();
            unlockScroll();
        })
        .on('hidden.bs.collapse', function () {
            if (isLocked) {
                unlockScroll();
            }
        });

    $(document.body).on('click', '.drawer-item .drawer-item-details-btn, .drawer-item .close-content', function () {
        $(this).parents('.drawer-item').find('.details-content').toggleClass('expanded');
    });
}

module.exports = {
    init: initPromoDrawer
};
